import React from 'react';
import * as _ from 'lodash';
import { useState, useEffect } from 'react';

import EntidadManager from './EntidadManager';
import Uuid from '../../../../../support/Uuid';
import ContabilidadList from './ContabilidadList';
import ContabilidadManager from './ContabilidadManager';

const Manager = (props) => {

  const [data, setData] = useState([]);
  const [entidad, setEntidad] = useState([]);
  const [editing, setEditing] = useState({});
  const [contabilidad, setContabilidad] = useState([]);
  const [showContabilidadManager, setShowContabilidadManager] = useState(false);

  const handleOnEntidadAdd = (value) => {
    const newData = [].concat(data, [{
      id: Uuid.v4(),
      ...value,
    }]);

    setData( newData );
  }

  const handleOnEntidadListChange = (itemEntidad, listEntidad) => {
    /**
     * TODO
     * Warning para eliminar una entidad y su relacion con array de contabilidad
     */
    const { Contabilidad } = itemEntidad;

    if (!_.isEmpty(Contabilidad)) {
      setContabilidad(contabilidad.filter((value) => itemEntidad.id !== value.entidad))
    }

    setData(listEntidad);
  }

  const handleOnContabilidadShowForm = (item) => {
    setEntidad(item);

    setShowContabilidadManager(!showContabilidadManager);
  }

  const handleOnContabilidadAdd = (itemContabilidad) => {
    setContabilidad( [].concat(contabilidad, itemContabilidad) );

    setShowContabilidadManager(!showContabilidadManager);
  }

  const handleOnContabilidadEdit = (item) => {
    setEditing(item);

    setShowContabilidadManager(!showContabilidadManager);

    setContabilidad(contabilidad.filter((value) => value.id !== item.id));

    setTimeout(() => {
      setEditing({});
    }, 500);
  }

  const handleOnContabilidadListChange = (item) => {
    setContabilidad(contabilidad.filter((value) => item.id !== value.id));
  }

  useEffect(() => {
    props.onEntidadAdd({ Entidad: data });
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let newData = [];
    let newContabilidad = [];

    data.map((entidad) => {
      contabilidad.map((item) => {
        if (entidad.id === item.entidad) {
          newContabilidad = [].concat(newContabilidad, item);
        }

        return item;
      });

      newData = [].concat(newData, {
        id: entidad.id,
        ClaveEntidad: entidad.ClaveEntidad,
        Ambito: entidad.Ambito,
        Contabilidad: newContabilidad
      });

      newContabilidad = [];

      return entidad;
    });

    setData(newData)
  }, [contabilidad]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (_.isEmpty(props.ruleData)) {
      setContabilidad([]);
      setData([]);
    }
  }, [props.ruleData])

  const handleOnClose = () => {
    setShowContabilidadManager(false);
  }

  return (
    <>
      <EntidadManager
        list={ data }
        ruleData={ props.ruleData }
        onEntidadAdd={ handleOnEntidadAdd }
        onChangeList={ handleOnEntidadListChange }
        onContabilidadAdd={ handleOnContabilidadShowForm }
      />

      { showContabilidadManager && (
        <ContabilidadManager
          entidad={ entidad }
          editing={ editing }
          onClose={ handleOnClose }
          onContabilidadAdd={ handleOnContabilidadAdd }
        />
      )}

      { !_.isEmpty(contabilidad) && (
        <ContabilidadList
          data={ contabilidad }
          onEdit={ handleOnContabilidadEdit }
          onListChange={ handleOnContabilidadListChange }
        />
      )}
    </>
  );
};

export default Manager;
